import React from 'react';
import { useHistory } from 'react-router-dom';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Visibility from '@mui/icons-material/Visibility';

import ListPage from '../../../sharedModules/listPage/ListPage';
import PlumbingIcon from '@mui/icons-material/Plumbing';

import { titleize } from '../../../utils/titleize';

const contactInfoToDisplay = {
  fax: 'fax_number',
  mail: 'mailing_address',
  online_portal: 'online_portal_url',
  email: 'contact_email',
};

const waterAuthorityColumns = [
  {
    name: 'Water Authority',
    selector: 'name',
    sortable: true,
    sortDirection: 'asc',
    grow: 1.5,
  },
  {
    name: 'Preferred Submit Method',
    selector: 'submission_method',
    sortable: true,
    cell: (row) => <p>{titleize(row.submission_method)}</p>,
  },
  {
    name: 'Contact Info ',
    selector: 'contact_info',
    sortable: true,
    grow: 1.5,
    cell: (row) => <p>{row?.[contactInfoToDisplay[row.submission_method]]}</p>,
  },
  {
    name: 'PDF Template',
    selector: 'pdf_template_url',
    grow: 0.5,
    cell: (row) =>
      row.pdf_template_url && (
        <a href={row.pdf_template_url} target="_blank" rel="noopener noreferrer">
          <Button variant="contained" color="primary">
            <Visibility />
          </Button>
        </a>
      ),
  },
];

const CreateButton = () => {
  const history = useHistory();

  return (
    <Grid container justifyContent="flex-end">
      <Button variant="contained" color="primary" onClick={() => history.push('/backflows/water_authorities/new')}>
        Add Water Authority
      </Button>
    </Grid>
  );
};

const WaterAuthorityListPage: React.FC = () => {
  return (
    <ListPage
      beforeComponent={<CreateButton />}
      clickableRows
      columns={waterAuthorityColumns}
      controller="backflows/water_authorities"
      titleIcon={<PlumbingIcon />}
      title="Water Authority Config"
    />
  );
};

export default WaterAuthorityListPage;
